import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { datadogRum } from '@datadog/browser-rum';
import { faStar } from '@fortawesome/pro-solid-svg-icons';
import { HubspotSubmitterService } from '../hubspot-subscribe-dialog/hubspot-submitter.service';

@Component({
  selector: 'realwear-cloud-hubspot-demo-dialog',
  templateUrl: './hubspot-demo-dialog.component.html',
  styleUrls: ['./hubspot-demo-dialog.component.scss'],
  providers: [HubspotSubmitterService]
})
export class HubspotDemoDialogComponent {
  readonly starIcon = faStar;

  constructor(private matDialogRef: MatDialogRef<unknown>, @Inject(MAT_DIALOG_DATA) private packageName: string) {}

  onNavigate(rootUrl: string) {
    datadogRum.addAction('RequestDemoComplete', { packageName: this.packageName, rootUrl });

    window.open(rootUrl + '?application=' + this.packageName);

    this.matDialogRef.close();
  }
}
